import axios from "axios";
export default {
    getDocumentMapData: (documentId) => axios.post("/Documents/GetDocumentMapData", { documentId }),
    saveDocumentMapData: (document) => axios.post("/Documents/SaveDocumentMapData", document)
};
